import * as React from 'react';

import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import { useLoyaltyPoints } from 'hooks/loyalty/use-loyalty-points';
import { LoyaltyUser } from 'state/loyalty/hooks/types';
import { routes } from 'utils/routing';

import {
  AvailableBalance,
  AvailablePoints,
  Divider,
  ExpirationDateTime,
  ExpirationMessage,
  NormalText,
  PointsExpirationContainer,
  PointsExpirationContent,
  PointsExpirationHeader,
  PurchaseMessage,
  StyledLoyaltyPointsIcon,
  StyledRewardsLogo,
} from './points-expiration.styled';

export const PointsExpirationCard: React.FC<React.PropsWithChildren<{
  loyaltyUser: LoyaltyUser;
}>> = ({ loyaltyUser }) => {
  const {
    userHasExpiringPoints,
    pointsExpirationDate,
    currentPoints,
    pointsToExpire,
    isNewPointsModel,
  } = useLoyaltyPoints(loyaltyUser);
  const { formatMessage } = useIntl();

  const pointsAndCrowns = (points: number) => (
    <>
      <StyledLoyaltyPointsIcon />
      <AvailablePoints>{points}</AvailablePoints>
    </>
  );

  return (
    <PointsExpirationContainer testID="points-expiration-card">
      <PointsExpirationHeader>
        <StyledRewardsLogo />
        <AvailableBalance>
          <NormalText>{formatMessage({ id: 'youHave' })}</NormalText>
          {pointsAndCrowns(currentPoints)}
          <NormalText>{formatMessage({ id: 'available' }).toLocaleLowerCase()}</NormalText>
        </AvailableBalance>
      </PointsExpirationHeader>
      <Divider />
      <PointsExpirationContent>
        <ExpirationMessage>
          {userHasExpiringPoints && isNewPointsModel && pointsAndCrowns(pointsToExpire)}
          <NormalText>
            {formatMessage({
              id: isNewPointsModel ? 'crownsWillExpireOn' : 'yourPointsWillExpire',
            })}
          </NormalText>
        </ExpirationMessage>
        <ExpirationDateTime testID="expiration-datetime">
          {pointsExpirationDate.formatted}
        </ExpirationDateTime>
        {!userHasExpiringPoints && (
          <PurchaseMessage>{formatMessage({ id: 'maintainYourPoints' })}</PurchaseMessage>
        )}
        <ActionButton fullWidth to={routes.menu}>
          {formatMessage({ id: 'orderNow' })}
        </ActionButton>
      </PointsExpirationContent>
    </PointsExpirationContainer>
  );
};
